import { render, staticRenderFns } from "./AnswerRadio.vue?vue&type=template&id=cf52ed30"
import script from "./AnswerRadio.vue?vue&type=script&lang=js"
export * from "./AnswerRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports